import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
    // root: {
    //     flexGrow: 1,
    //     paddingLeft:90
    //   },
    // Filter Section
    formOneLbl: {},
    formOneinputWrapper: {
        margin: '10px 0 10px 0',
        "& .MuiInputBase-root": {
            borderRadius: '4px',
            //border: '1px solid #c0c1c1',
            padding: '0px 0',
            width: '100%',
            background: '#f7fcff',
            float: 'left',

        },
        "& .MuiOutlinedInput-input": {
            padding: '12px 5px',
        },
        "& .MuiInput-root": {
            position: 'relative',
            width: '100%',
            border: '1px solid #ccc !important',
            borderRadius: '4px',
            padding: '4px 0',
            background: '#f7fcff',
            float: 'left',
        },

        "& .MuiTextField-root": {

            fontSize: '2px',
            background: '#fff',
            padding: '0 0 0 0',
            borderRadius: '5px',
            border: 'unset',
            margin: '2px',
            width: '100%',
        },
        "& .MuiInput-underline:before": {
            borderBottom: 'unset',
        },
        "& .MuiInput-underline:after": {
            borderBottom: '1px solid #ccc',
        },
        "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {

            padding: '0px 0 0 0',
        },
        "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input": {

            padding: '6px 4px',
            fontSize: '12px',
        },
        "& .makeStyles-filterSection-149 .MuiTextField-root": {

            border: '1px solid #333',
        },
        "& .makeStyles-root-139 .MuiIconButton-root": {

            padding: '0px 0',
            margin: '0px 0',
        },
        // "& input":{
        //              borderRadius: '4px',
        //              border: '1px solid #c0c1c1',
        //              padding: '8px 0',
        //              width:'100%',
        //             background:'#f7fcff',
        //              float: 'left',
        //          },
        "& select": {
            borderRadius: '4px',
            border: '1px solid #c0c1c1',
            padding: '12px 0',
            width: '100%',
            background: '#f7fcff',
            float: 'left',
        },
        "& .makeStyles-root-25 .MuiIconButton-root": {
            padding: '4px 0',
        },
        "& .MuiList-padding": {
            paddingTop: '10px !important',
        },
    },
    createHeader: {
        padding: '30px 0px 25px 0',
    },
    createHeaderLine: {
        height: '2px',
        margin: '8px 0 0 5px',
        display: 'flex',
        padding: '0 !important',
        minWidth: '81%',
        background: '#e2e2e2',

    },
    createHeaderTxt: {
        fontWeight: 'bold',
        textTransform: 'uppercase',
        fontSize: '16px',
        textAlign: 'left',
    },
    contentOuterBG: {
        backgroundColor: '#fff;',
        padding: '10px 15px',
        borderRadius: '15px',
    },
    createWrapper: {},




    inputWrapper: {
        margin: '10px 0 10px 0',
        "& .MuiInputBase-root": {
            borderRadius: '4px',
            //border: '1px solid #c0c1c1',
            padding: '0px 0',
            width: '100%',
            background: '#f7fcff',
            float: 'left',

        },
        "& .MuiOutlinedInput-input": {
            padding: '10px 5px',
            textAlign: 'left',
            maxHeight: '20px',
        },
        "& .MuiInput-root": {
            position: 'relative',
            width: '100%',
            border: '1px solid #ccc !important',
            borderRadius: '4px',
            padding: '4px 0',
            background: '#f7fcff',
            float: 'left',
        },

        "& .MuiTextField-root": {

            fontSize: '2px',
            background: '#fff',
            padding: '0 0 0 0',
            borderRadius: '5px',
            border: 'unset',
            margin: '2px',
            width: '100%',
        },
        "& .MuiInput-underline:before": {
            borderBottom: 'unset',
        },
        "& .MuiInput-underline:after": {
            borderBottom: '1px solid #ccc',
        },
        "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {

            padding: '0px 0 0 0',
        },
        "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input": {

            padding: '6px 4px',
            fontSize: '12px',
        },
        "& .makeStyles-filterSection-149 .MuiTextField-root": {

            border: '1px solid #333',
        },
        "& .makeStyles-root-139 .MuiIconButton-root": {

            padding: '0px 0',
            margin: '0px 0',
        },
        // "& input":{
        //              borderRadius: '4px',
        //              border: '1px solid #c0c1c1',
        //              padding: '8px 0',
        //              width:'100%',
        //             background:'#f7fcff',
        //              float: 'left',
        //          },
        "& select": {
            borderRadius: '4px',
            border: '1px solid #c0c1c1',
            padding: '12px 0',
            width: '100%',
            background: '#f7fcff',
            float: 'left',
        },
        "& .makeStyles-root-25 .MuiIconButton-root": {
            padding: '4px 0',
        },
        "& .MuiList-padding": {
            paddingTop: '10px !important',
        },
    },

    inputWrapper_Req: {
        margin: '10px 0 10px 0',
        "& .MuiChip-root": {
            height: '23px',
        },
        "& .MuiInputBase-root": {
            borderRadius: '4px',
            //border: '1px solid #c0c1c1',
            padding: '0px 0',
            width: '100%',
            background: '#f7fcff',
            float: 'left',

        },
        "& .MuiOutlinedInput-input": {
            padding: '10px 5px',
            borderRight: '5px solid #ed1c24',
            borderRadius: '0 4px 4px 0',
            textAlign: 'left',
            maxHeight: '20px',
        },
        "& .MuiInput-root": {
            position: 'relative',
            width: '100%',
            border: '1px solid #ed1c24 !important',
            borderRadius: '4px',
            padding: '4px 0',
            background: '#f7fcff',
            float: 'left',
            borderRight: '5px solid #ed1c24 !important',
        },
        "& .MuiTextField-root": {

            fontSize: '2px',
            background: '#fff',
            padding: '0 0 0 0',
            borderRadius: '5px',
            border: 'unset',
            margin: '2px',
            width: '100%',
        },
        "& .MuiInput-underline:before": {
            borderBottom: 'unset',
        },
        "& .MuiInput-underline:after": {
            borderBottom: '1px solid #ccc',
        },
        "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {

            padding: '0px 0 0 0',
        },
        "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input": {

            padding: '6px 4px',
            fontSize: '12px',
        },
        "& .makeStyles-filterSection-149 .MuiTextField-root": {

            border: '1px solid #333',
        },
        "& .makeStyles-root-139 .MuiIconButton-root": {

            padding: '0px 0',
            margin: '0px 0',
        },
        "& select": {
            borderRadius: '4px',
            border: '1px solid #c0c1c1',
            padding: '12px 0',
            width: '100%',
            background: '#f7fcff',
            float: 'left',
            borderRight: '5px solid #ed1c24 !important',
        },
        "& .makeStyles-root-25 .MuiIconButton-root": {

            padding: '4px 0',
        },
        "& .MuiList-padding": {
            paddingTop: '10px !important',
        },
    },
    filterheader: {
        fontSize: '14px',
        margin: '16px 0 0 0 !important',
        fontWeight: 'bold',
        textTransform: 'uppercase',
    },
    createLbl: {
        textAlign: 'left',
        float: 'left',
        fontSize: '12px',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        margin: '0 0 2px 0',

    },
    // inputWrapper:{

    //     "& input":{
    //         borderRadius: '4px',
    //         border: '1px solid #c0c1c1',
    //         padding: '8px 0',
    //         width:'100%',
    //         background:'#f7fcff',
    //         float: 'left',
    //     },
    //     "& select":{
    //         borderRadius: '4px',
    //         border: '1px solid #c0c1c1',
    //         padding: '8px 0',
    //         width:'100%',
    //         background:'#f7fcff',
    //         float: 'left',
    //     },
    // },
    textWrap: {
        width: '100%',
        padding: '12px 5px 6px 5px',
        background: '#fff',
        minHeight: '21px',
        textAlign: 'left',
        fontWeight: 'bold',
        fontSize: '14px',
        textTransform: 'uppercase',
        float: 'left',
        border: '1px solid #ddd',
        borderRadius: '4px',
    },
    BtnArea: {
        float: 'right',
        width: '100%',
    },
    reqLbl: {
        float: 'left',
        width: '20%',
        margin: '20px 0 0 0',
        "& span": {
            float: 'left',
            fontSize: '12px',
            borderLeft: '4px solid #ed1c24',
            textTransform: 'uppercase',
            padding: '2px 0 2px 10px',
            fontWeight: 'bold',

        },
    },
    BtnGreenWrapper: {
        "& button": {
            color: '#fff',
            float: 'right',
            border: 'none',
            padding: '8px 20px 5px 20px',
            background: '#19c626',
            borderRadius: '20px',
            textTransform: 'uppercase',
            fontWeight: 'bold',
            margin: '8px 5px',
            "& .MuiSvgIcon-root": {
                margin: '-5px 5px 0 0',
                float: 'left',
            },
        },

        "& button:hover": {
            background: '#11ac1c',
        },

    },
    BtnBlackWrapper: {
        "& button": {
            color: '#fff',
            float: 'right',
            border: 'none',
            background: '#414141',
            borderRadius: '20px',
            padding: '7px 20px',
            textTransform: 'uppercase',
            fontWeight: 'bold',
            margin: '8px 5px',
        },
        "& button:hover": {
            background: '#000',
        },
    },

    fileWrapper: {
        margin: '16px 0 0 0',
        "& input": {
            background: '#ccc',
        },
        "& input[type='file']": {
            float: 'left',
            padding: '10px 2px',
            background: '#f7fcff',
            borderRadius: '4px',
            border: '1px solid #ccc',
            width: '51%',
        },
        "& .MuiButton-contained.Mui-disabled": {
            backgroundColor: '#05ae2a !important',
            color: '#fff',
            padding: '2px 10px !important',
            margin: '8px 0 0 5px',
            float: 'left',
        },
        "& .MuiButton-containedPrimary": {
            backgroundColor: '#05ae2a !important',
            color: '#fff',
            padding: '2px 10px !important',
            margin: '8px 0 0 5px',
            float: 'left',
        },
        "& a": {
            background: '#00a4dd',
            textDecoration: 'none',
            color: '#fff',
            margin: '7px 0 0 5px',
            padding: '6px 7px 7px 6px',
            borderRadius: '4px',
            textTransform: 'uppercase',
            fontSize: '14px',
            float: 'left',
        },
    },
    helpLbl: {
        textAlign: 'left',
        float: 'left',
        fontSize: '12px',
        color: '#02268b',
        fontStyle: 'italic',
        width: '100%',
        margin: '0 0 2px 0',
    },
}));

export default useStyles;
